import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import type { NavItem } from "@/config/navigation";

interface SidebarCategoryProps {
  item: NavItem;
  isExpanded: boolean;
  hasActiveChild: boolean;
  onToggle: () => void;
  collapsed?: boolean;
}

export function SidebarCategory({
  item,
  isExpanded,
  hasActiveChild,
  onToggle,
  collapsed = false,
}: SidebarCategoryProps) {
  const Icon = item.icon;

  return (
    <button
      onClick={onToggle}
      className={cn(
        "w-full flex items-center gap-2 p-2 rounded-md transition-all duration-200",
        "text-[hsl(var(--sidebar-text))] hover:bg-[hsl(var(--sidebar-bg-hover))]",
        isExpanded && "bg-[hsl(var(--sidebar-bg-hover))] border-l-3 border-[hsl(var(--sidebar-accent))]",
        hasActiveChild && !isExpanded && "border-l-3 border-[hsl(var(--sidebar-accent))]"
      )}
    >
      <Icon className="h-4 w-4 flex-shrink-0" />
      {!collapsed && (
        <>
          <span className="flex-1 text-left text-sm font-medium">{item.label}</span>
          <ChevronDown
            className={cn(
              "h-4 w-4 transition-transform duration-200",
              isExpanded && "rotate-180"
            )}
          />
        </>
      )}
    </button>
  );
}
